import { useCallback, useEffect, useState } from "react";
import { WaMessageService } from "../services/WaMessageService";

export const useHookWaMessage = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Sesuaikan parameter state dengan backend
    const [params, setParams] = useState({
        page: 1,
        per_page: 10,        
        sender: "",          
        recipient: "",       
        order_by: "created_at",      
        sort_dir: "desc",    
    });

    // Destructure semua nilainya agar terdeteksi perubahannya oleh useCallback
    const { page, per_page, sender, recipient, order_by, sort_dir } = params;

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            // Kirim parameter yang namanya sudah disesuaikan dengan backend
            const res = await WaMessageService.get({params: params});
            
            setData(res.data.data);
            setMeta(res.data.meta);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [page, per_page, sender, recipient, order_by, sort_dir]);

    // Jalankan otomatis saat parameter berubah
    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        meta,
        loading,
        error,
        
        params,
        setParams,

        refreshData: getData,
    };
};